/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SupportUpdateRewardLedgerEntryRequest
 */
export interface SupportUpdateRewardLedgerEntryRequest {
    /**
     * 
     * @type {string}
     * @memberof SupportUpdateRewardLedgerEntryRequest
     */
    userId: string;
    /**
     * 
     * @type {number}
     * @memberof SupportUpdateRewardLedgerEntryRequest
     */
    ledgerEntryId: number;
    /**
     * 
     * @type {number}
     * @memberof SupportUpdateRewardLedgerEntryRequest
     */
    amount: number;
    /**
     * 
     * @type {boolean}
     * @memberof SupportUpdateRewardLedgerEntryRequest
     */
    pending: boolean;
}

/**
 * Check if a given object implements the SupportUpdateRewardLedgerEntryRequest interface.
 */
export function instanceOfSupportUpdateRewardLedgerEntryRequest(value: object): value is SupportUpdateRewardLedgerEntryRequest {
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('ledgerEntryId' in value) || value['ledgerEntryId'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    if (!('pending' in value) || value['pending'] === undefined) return false;
    return true;
}

export function SupportUpdateRewardLedgerEntryRequestFromJSON(json: any): SupportUpdateRewardLedgerEntryRequest {
    return SupportUpdateRewardLedgerEntryRequestFromJSONTyped(json, false);
}

export function SupportUpdateRewardLedgerEntryRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SupportUpdateRewardLedgerEntryRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['user_id'],
        'ledgerEntryId': json['ledger_entry_id'],
        'amount': json['amount'],
        'pending': json['pending'],
    };
}

export function SupportUpdateRewardLedgerEntryRequestToJSON(json: any): SupportUpdateRewardLedgerEntryRequest {
    return SupportUpdateRewardLedgerEntryRequestToJSONTyped(json, false);
}

export function SupportUpdateRewardLedgerEntryRequestToJSONTyped(value?: SupportUpdateRewardLedgerEntryRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'user_id': value['userId'],
        'ledger_entry_id': value['ledgerEntryId'],
        'amount': value['amount'],
        'pending': value['pending'],
    };
}

